import { useTranslation } from "react-i18next";

interface VersionBadgeProps {
  isLatest?: boolean;
}

export function VersionBadge({ isLatest }: VersionBadgeProps) {
  const { t } = useTranslation();

  if (!isLatest) return null;

  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
      {t("changelog.latest")}
    </span>
  );
}
